import {createSelector, MemoizedSelector} from '@ngrx/store';

import {State} from '../state';
import {selectState} from './pathways-state.selector';

const getKnowledgeBase = (state: State): any => state.knowledgeBase;

export const selectKnowledgeBase: MemoizedSelector<object, string> = createSelector(
  selectState,
  getKnowledgeBase);
